import React from 'react';

const Services = () => {
  return (
    <section id="services" className="py-20 md:py-32 bg-[#F8FAFC]">
      <div className="container mx-auto px-6 md:px-12">
        
        {/* Header - Improved mobile typography */}
        <div className="mb-12 md:mb-20 text-center lg:text-left">
          <span className="text-[#D62828] font-bold uppercase tracking-[0.4em] text-[10px] md:text-xs">Our Expertise</span>
          <h2 className="text-4xl md:text-6xl font-black text-[#0A1D37] mt-3 uppercase tracking-tighter leading-none">
            Software <span className="text-transparent" style={{ WebkitTextStroke: '1px #0A1D37' }}>Solutions</span>
          </h2>
          <div className="h-1.5 w-20 bg-[#D62828] mt-6 mx-auto lg:mx-0"></div>
        </div>

        {/* Bento Grid - Responsive span logic */}
        <div className="grid grid-cols-1 md:grid-cols-6 gap-6 md:gap-8">
          
          {/* Main Service - Website (Large Card) */}
          <div className="md:col-span-6 lg:col-span-4 bg-white p-8 md:p-12 shadow-sm border border-slate-100 hover:shadow-xl transition-all group relative overflow-hidden">
            <div className="relative z-10">
              <i className="fas fa-code text-3xl md:text-4xl text-[#D62828] mb-6 block"></i>
              <h3 className="text-2xl md:text-3xl font-[900] text-[#0A1D37] mb-4">Website Development</h3>
              <p className="text-slate-500 max-w-md leading-relaxed text-sm md:text-base">
                High-performance, SEO-ready web platforms built with React and Tailwind for maximum scalability.
              </p>
            </div>
            {/* Background number hidden on small mobile to avoid text overlap */}
            <div className="absolute -right-6 -bottom-6 text-[8rem] md:text-[12rem] font-black text-slate-50 opacity-40 group-hover:text-slate-100 transition-colors pointer-events-none select-none">01</div>
          </div>

          {/* SEO (Dark Card) */}
          <div className="md:col-span-3 lg:col-span-2 bg-[#0A1D37] p-8 md:p-10 shadow-sm hover:shadow-xl transition-all group">
            <i className="fas fa-chart-line text-2xl md:text-3xl text-[#D62828] mb-6 block"></i>
            <h3 className="text-xl font-bold text-white mb-3">SEO Growth</h3>
            <p className="text-slate-400 text-sm leading-relaxed">
              Data-driven search engine strategies to dominate rankings and capture local market share.
            </p>
          </div>

          {/* Desktop Apps (Small Card) */}
          <div className="md:col-span-3 lg:col-span-2 bg-white p-8 md:p-10 shadow-sm border border-slate-100 hover:shadow-xl transition-all group">
            <i className="fas fa-desktop text-2xl md:text-3xl text-[#D62828] mb-6 block"></i>
            <h3 className="text-xl font-bold text-[#0A1D37] mb-3">Desktop Software</h3>
            <p className="text-slate-500 text-sm leading-relaxed">
              Robust Windows and Mac applications built for offline stability and complex business logic.
            </p>
          </div>

          {/* Entrepreneur Support (Medium Card) */}
          <div className="md:col-span-6 lg:col-span-4 bg-white p-8 md:p-12 shadow-sm border border-slate-100 hover:shadow-xl transition-all group flex flex-col justify-between border-t-4 border-t-[#D62828]">
            <div>
              <h3 className="text-2xl font-[900] text-[#0A1D37] mb-4 uppercase tracking-tight">Entrepreneur Support</h3>
              <p className="text-slate-500 leading-relaxed text-sm md:text-base">
                Consultancy and digital tools designed specifically to help startups transition into established enterprises with automated workflows.
              </p>
            </div>
            <div className="flex items-center mt-10 space-x-4 text-[#0A1D37] font-black text-[10px] md:text-xs uppercase tracking-[0.2em] cursor-pointer hover:text-[#D62828] transition-colors">
              <span>Learn More</span>
              <i className="fas fa-arrow-right group-hover:translate-x-2 transition-transform"></i>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default Services;